import React, { useState } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

export const Header = () => {
  const [hoveredLink, setHoveredLink] = useState(null);

  const navItems = [
    { key: 'home', label: 'मुखपृष्ठ', path: '/' },
    { key: 'legacy', label: 'गौरवशाली विरासत', path: '/Gaurvshali' },
    { key: 'manifesto', label: 'घोषणापत्र', path: '/manifesto' },
    { key: 'vision', label: 'दृष्टि और मिशन', path: '/vision-mission' },
    { key: 'darbar', label: 'जनता दरबार', path: '/janta-darbar' },
    { key: 'contact', label: 'संपर्क', path: '/contact' }
  ];

  const headerStyles = {
    navbar: {
      backgroundColor: 'var(--white-pure)',
      borderBottom: '3px solid var(--saffron-deep)',
      boxShadow: '0 4px 12px rgba(229, 123, 28, 0.1)',
      padding: '0.6rem 0'
    },
    brandContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      flexWrap: 'wrap'
    },
    lotusIcon: {
      color: 'var(--saffron-deep)',
      fontSize: '1.8rem'
    },
    brandName: {
      fontWeight: 700,
      fontSize: '1.1rem',
      color: '#1e1e1e',
      lineHeight: 1.2
    },
    brandSubtitle: {
      display: 'block',
      color: 'var(--saffron-deep)',
      fontSize: '0.8rem'
    },
    brandLegacy: {
      fontSize: '0.7rem',
      color: 'var(--saffron-dark)',
      fontStyle: 'italic',
      marginTop: '0.2rem',
      lineHeight: 1.2
    },
    navLink: {
      color: '#2c2c2c',
      fontSize: '0.95rem',
      fontWeight: 500,
      padding: '0.6rem',
      margin: '0.2rem 0',
      borderBottom: '1px solid #eee',
      display: 'block',
      width: '100%',
      textAlign: 'center',
      textDecoration: 'none'
    },
    navLinkHover: {
      color: 'var(--saffron-deep)',
      borderBottom: '2px solid var(--saffron-deep)'
    },
    activeNavLink: {
      color: 'var(--saffron-deep)',
      borderBottom: '2px solid var(--saffron-deep)'
    },
    toggler: {
      borderColor: 'var(--saffron-deep)'
    },
    togglerIcon: {
      backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='%23E57B1C' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e")`
    }
  };

  return (
    <Navbar expand="lg" style={headerStyles.navbar} fixed="top">
      <Container>

        {/* 🔶 BRAND / LOGO */}
        <Navbar.Brand
          as={NavLink}
          to="/"
          className="p-0 d-flex align-items-center flex-wrap"
          style={headerStyles.brandContainer}
        >
          <i className="fas fa-lotus" style={headerStyles.lotusIcon}></i>

          <div style={{ maxWidth: '220px' }}>
            <div style={headerStyles.brandName}>
              पंडित धीरेंद्र कुमार शर्मा
              <span style={headerStyles.brandSubtitle}>
                (एक संकल्पित राष्ट्रवादी नेता)
              </span>
            </div>

            <div className="brand-legacy" style={headerStyles.brandLegacy}>
              <i
                className="fas fa-star fa-xs"
                style={{ color: 'var(--saffron-deep)' }}
              ></i>
              {' '}पौत्र: अमर स्वतंत्रता सेनानी पंडित भगवान दीन शर्मा जी
            </div>
          </div>
        </Navbar.Brand>

        {/* 🔘 TOGGLER */}
        <Navbar.Toggle aria-controls="main-nav" style={headerStyles.toggler}>
          <span className="navbar-toggler-icon" style={headerStyles.togglerIcon}></span>
        </Navbar.Toggle>

        {/* 🔗 NAV LINKS */}
        <Navbar.Collapse id="main-nav" className="mt-2 mt-lg-0">
          <Nav className="ms-auto align-items-lg-center text-center w-100">

            {navItems.map((item) => (
              <NavLink
                key={item.key}
                to={item.path}
                style={({ isActive }) => ({
                  ...headerStyles.navLink,
                  ...(hoveredLink === item.key ? headerStyles.navLinkHover : {}),
                  ...(isActive ? headerStyles.activeNavLink : {})
                })}
                onMouseEnter={() => setHoveredLink(item.key)}
                onMouseLeave={() => setHoveredLink(null)}
              >
                {item.label}
              </NavLink>
            ))}

          </Nav>
        </Navbar.Collapse>

      </Container>
    </Navbar>
  );
};

export default Header;